module.exports = __webpack_public_path__ + "static/media/hshs-logo.d0342317.png";